import { GuideOrderThemeModeConfig } from './types';

const light: GuideOrderThemeModeConfig = {
  guideOrder: {},
};

export default light;
